<template>

<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M378.993,391.055v-24.859c9.463,0.706,12.712,5.226,16.667,5.226c5.227,0,7.486-6.497,7.486-9.746
			c0-8.192-14.972-10.876-24.152-11.158v-3.672c0-1.836-2.401-3.531-4.802-3.531c-2.684,0-4.803,1.695-4.803,3.531v3.955
			c-14.124,1.836-27.401,9.605-27.401,27.543c0,18.079,14.548,23.588,27.401,28.39v28.108c-12.43-1.412-16.667-10.593-22.034-10.593
			c-4.379,0-7.91,5.933-7.91,9.888c0,7.909,12.853,17.09,29.944,17.514h-0.001v3.953c0,1.836,2.119,3.531,4.803,3.531
			c2.401,0,4.802-1.695,4.802-3.531v-4.379c15.819-2.542,26.695-12.57,26.695-29.944
			C405.688,402.072,391.564,395.716,378.993,391.055z M370.519,387.949c-6.497-2.542-11.299-5.226-11.299-11.441
			c0-5.367,4.236-8.757,11.299-9.887V387.949z M377.864,434.701v-24.576c6.073,2.683,10.593,6.073,10.593,12.994
			C388.457,429.758,384.079,433.43,377.864,434.701z"/>
	</g>
</g>
<g>
	<g>
		<path d="M146.214,107.159l-9.678-17.53c5.553-2.141,9.598-7.218,9.598-16.102c0-12.929-8.646-16.975-19.513-16.975h-16.42
			c-2.3,0-3.807,1.745-3.807,3.728h0.001v50.449c0,2.538,3.093,3.807,6.187,3.807c3.093,0,6.187-1.269,6.187-3.807V91.612h5.235
			l10.867,21.1c0.872,1.666,2.38,2.3,3.966,2.3c3.649,0,7.774-3.332,7.774-6.425C146.611,108.19,146.531,107.635,146.214,107.159z
			 M126.621,82.094h-7.853V67.34h7.853c4.442,0,7.139,1.825,7.139,7.377C133.76,80.27,131.063,82.094,126.621,82.094z"/>
	</g>
</g>
<g>
	<g>
		<path d="M190.315,103.749h-21.258V90.264h11.898c2.618,0,3.728-2.538,3.728-4.68c0-2.539-1.348-4.839-3.728-4.839h-11.898V67.339
			h21.258c2.379,0,3.728-2.538,3.728-5.473c0-2.539-1.11-5.315-3.728-5.315h-28.239c-2.697,0-5.394,1.27-5.394,3.808v50.37
			c0,2.538,2.697,3.807,5.394,3.807h28.239c2.618,0,3.728-2.776,3.728-5.314C194.043,106.287,192.695,103.749,190.315,103.749z"/>
	</g>
</g>
<g>
	<g>
		<path d="M234.893,92.564c-3.173,0-5.87,0.794-6.108,3.729c-0.238,3.093-0.635,7.932-6.981,7.932c-4.601,0-7.218-2.538-7.218-7.932
			V75.272c0-5.394,2.617-7.932,7.139-7.932c6.742,0,6.98,5.076,7.06,7.139c0.159,2.855,2.855,3.728,6.187,3.728
			c4.204,0,6.187-1.111,6.187-5.87c0-10.074-8.567-15.785-19.91-15.785c-10.391,0-19.037,5.076-19.037,18.72v21.02
			c0,13.643,8.646,18.72,19.037,18.72c11.343,0,19.91-6.028,19.91-16.578C241.159,93.675,239.176,92.564,234.893,92.564z"/>
	</g>
</g>
<g>
	<g>
		<path d="M285.022,103.749h-21.258V90.264h11.898c2.618,0,3.729-2.538,3.729-4.68c0-2.539-1.349-4.839-3.729-4.839h-11.898V67.339
			h21.258c2.38,0,3.729-2.538,3.729-5.473c0-2.539-1.111-5.315-3.729-5.315h-28.239c-2.697,0-5.394,1.27-5.394,3.808v50.37
			c0,2.538,2.697,3.807,5.394,3.807h28.239c2.618,0,3.729-2.776,3.729-5.314C288.751,106.287,287.402,103.749,285.022,103.749z"/>
	</g>
</g>
<g>
	<g>
		<path d="M304.294,56.552c-3.093,0-6.187,1.111-6.187,3.728v50.449c0,2.538,3.094,3.807,6.187,3.807s6.187-1.269,6.187-3.807V60.28
			C310.481,57.663,307.387,56.552,304.294,56.552z"/>
	</g>
</g>
<g>
	<g>
		<path d="M344.034,56.552h-16.42c-2.776,0-4.601,1.745-4.601,3.728h0.001v50.45c0,2.538,3.094,3.807,6.187,3.807
			s6.187-1.269,6.187-3.807V93.596h7.853c10.946,0,19.513-5.077,19.513-18.403v-0.397C362.754,61.47,354.505,56.552,344.034,56.552z
			 M350.379,76.145c0,5.394-2.697,7.932-7.139,7.932h-7.853V67.341h7.853c4.442,0,7.139,2.538,7.139,7.932V76.145z"/>
	</g>
</g>
<g>
	<g>
		<path d="M406.457,56.552H372.19c-2.618,0-3.728,2.856-3.728,5.473c0,3.015,1.348,5.632,3.728,5.632h10.947v43.072
			c0,2.538,3.094,3.807,6.187,3.807s6.187-1.269,6.187-3.807V67.657h10.946c2.38,0,3.728-2.617,3.728-5.632
			C410.185,59.408,409.075,56.552,406.457,56.552z"/>
	</g>
</g>
<g>
	<g>
		<path d="M290.01,161.487H106.958c-4.143,0-7.502,3.359-7.502,7.502s3.359,7.502,7.502,7.502H290.01
			c4.144,0,7.502-3.359,7.502-7.502C297.512,164.845,294.154,161.487,290.01,161.487z"/>
	</g>
</g>
<g>
	<g>
		<path d="M290.01,204.679H106.958c-4.143,0-7.502,3.359-7.502,7.502s3.359,7.502,7.502,7.502H290.01
			c4.144,0,7.502-3.359,7.502-7.502C297.512,208.037,294.154,204.679,290.01,204.679z"/>
	</g>
</g>
<g>
	<g>
		<path d="M290.01,257.502H106.958c-4.143,0-7.502,3.359-7.502,7.502s3.359,7.502,7.502,7.502H290.01
			c4.144,0,7.502-3.359,7.502-7.502S294.154,257.502,290.01,257.502z"/>
	</g>
</g>
<g>
	<g>
		<path d="M290.01,300.694H106.958c-4.143,0-7.502,3.359-7.502,7.502s3.359,7.502,7.502,7.502H290.01
			c4.144,0,7.502-3.359,7.502-7.502S294.154,300.694,290.01,300.694z"/>
	</g>
</g>
<g>
	<g>
		<path d="M398.446,161.487h-54.218c-4.144,0-7.502,3.359-7.502,7.502s3.358,7.502,7.502,7.502h54.218
			c4.144,0,7.502-3.359,7.502-7.502C405.948,164.845,402.59,161.487,398.446,161.487z"/>
	</g>
</g>
<g>
	<g>
		<path d="M398.446,204.679h-54.218c-4.144,0-7.502,3.359-7.502,7.502s3.358,7.502,7.502,7.502h54.218
			c4.144,0,7.502-3.359,7.502-7.502C405.948,208.037,402.59,204.679,398.446,204.679z"/>
	</g>
</g>
<g>
	<g>
		<path d="M398.446,257.502h-54.218c-4.144,0-7.502,3.359-7.502,7.502s3.358,7.502,7.502,7.502h54.218
			c4.144,0,7.502-3.359,7.502-7.502S402.59,257.502,398.446,257.502z"/>
	</g>
</g>
<g>
	<g>
		<path d="M398.446,300.694h-54.218c-4.144,0-7.502,3.359-7.502,7.502s3.358,7.502,7.502,7.502h54.218
			c4.144,0,7.502-3.359,7.502-7.502C405.948,304.053,402.59,300.694,398.446,300.694z"/>
	</g>
</g>
<g>
	<g>
		<path d="M290.01,374.837H106.958c-4.143,0-7.502,3.359-7.502,7.502s3.359,7.502,7.502,7.502H290.01
			c4.144,0,7.502-3.359,7.502-7.502S294.154,374.837,290.01,374.837z"/>
	</g>
</g>
<g>
	<g>
		<path d="M290.01,418.03H106.958c-4.143,0-7.502,3.359-7.502,7.502s3.359,7.502,7.502,7.502H290.01
			c4.144,0,7.502-3.359,7.502-7.502S294.154,418.03,290.01,418.03z"/>
	</g>
</g>
<g>
	<g>
		<path d="M446.829,1.44c-1.941-1.413-4.441-1.814-6.717-1.078l-34.988,11.263L370.135,0.362c-1.495-0.482-3.103-0.482-4.598,0
			l-34.983,11.263L295.571,0.362c-1.497-0.482-3.104-0.482-4.599,0L255.99,11.625L221.009,0.362c-1.496-0.482-3.103-0.482-4.599,0
			l-34.977,11.263L146.451,0.362c-1.494-0.481-3.102-0.481-4.598,0L106.87,11.626L71.888,0.362
			c-2.281-0.736-4.779-0.335-6.717,1.078c-1.938,1.412-3.084,3.665-3.084,6.063v489.452c0,8.296,6.749,15.045,15.045,15.045h357.736
			c8.295,0,15.044-6.749,15.044-15.045V7.504C449.913,5.106,448.767,2.852,446.829,1.44z M434.869,496.997l-357.777-0.041V17.801
			l27.48,8.848c1.496,0.482,3.104,0.482,4.598,0l34.983-11.263l34.981,11.263c1.496,0.482,3.103,0.482,4.599,0l34.977-11.263
			l34.982,11.263c1.495,0.482,3.104,0.482,4.598,0l34.983-11.263l34.984,11.263c1.497,0.482,3.102,0.482,4.599,0l34.983-11.263
			l34.988,11.263c1.495,0.482,3.102,0.482,4.597,0l27.485-8.848L434.869,496.997z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
